'use client';
import PropTypes from 'prop-types';
import React__default, { useMemo } from 'react';
import { ColorSwatchLabelPositions, ColorSwatchesContext } from './color-swatches.context.js';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * The size of the color swatches
   * @default standard
   */ size: PropTypes.oneOf([
        'standard',
        'super'
    ]),
    /**
   * Where to position the label tooltips relative to its swatch
   * @default top
   */ labelPosition: PropTypes.oneOf(ColorSwatchLabelPositions)
};
const ColorSwatches = createComponent({
    displayName: 'ColorSwatches',
    root: 'div',
    propTypes,
    propConfig: {
        classNames (props) {
            const classNameSet = new Set([
                'swan-color-swatches'
            ]);
            const { size = 'standard' } = props;
            if (size != 'standard') classNameSet.add(`swan-color-swatches-${size}`);
            return classNameSet;
        },
        wrapRoot ({ labelPosition = 'top' }, _derivedProps, element) {
            const ctxValue = useMemo(()=>({
                    labelPosition
                }), [
                labelPosition
            ]);
            return /*#__PURE__*/ React__default.createElement(ColorSwatchesContext.Provider, {
                value: ctxValue
            }, element);
        }
    }
});

export { ColorSwatches };
